import React from 'react'
import facebookIconRoundImage from 'social_media/facebook-icon-round.png'
import googleIconRoundImage from 'social_media/google-icon-round.png'

const FACEBOOK_ICON_SRC = facebookIconRoundImage
const GOOGLE_ICON_SRC = googleIconRoundImage

const ProviderIcon = ({ src }) => (
  <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#f2f2f2]">
    <img
      src={src}
      alt=""
      className="h-8 w-8 object-contain"
      aria-hidden="true"
    />
  </div>
)

const PROVIDER_CONFIG = {
  facebook: {
    title: 'Continue with Facebook',
    description: 'Sign in or create an account using your Facebook account.',
    iconSrc: FACEBOOK_ICON_SRC,
  },
  google: {
    title: 'Continue with Google',
    description: 'Sign in or create an account using your Google account.',
    iconSrc: GOOGLE_ICON_SRC,
  },
}

const SocialAuthProviderPanel = ({ provider }) => {
  const config = PROVIDER_CONFIG[provider]

  if (!config) return null

  return (
    <div className="w-full px-3 py-4 bg-base-gray-10 rounded-5 flex flex-col items-center gap-4">
      <ProviderIcon src={config.iconSrc} />
      <div className="w-full flex flex-col items-center gap-2 text-center">
        <p className="w-full text-lg font-extrabold text-base-gray-text-main">
          {config.title}
        </p>
        <p className="w-full text-base font-medium text-base-gray-text-main">
          {config.description}
        </p>
      </div>
    </div>
  )
}

export default SocialAuthProviderPanel
